import { useEffect } from 'react';
import { resolveMediaUrl } from './mediaUrl';

const upsertMeta = (attribute, key, content) => {
  if (!content) return;

  let element = document.head.querySelector(`meta[${attribute}="${key}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }
  element.setAttribute('content', content);
};

export const usePropertyShareMeta = (property) => {
  useEffect(() => {
    if (!property) return undefined;

    const pageUrl = `${window.location.origin}/property/${property.id}`;
    const firstImage = (property.images || []).find((img) => img && String(img).trim());
    const imageUrl = firstImage ? resolveMediaUrl(firstImage) : `${window.location.origin}/premium-homes-logo.png`;
    const location = [property.location, property.address].filter(Boolean).join(', ');
    const description =
      (property.description && property.description.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim()) ||
      [property.title, location].filter(Boolean).join(' · ');

    const previousTitle = document.title;
    document.title = `${property.title} | Premium Homes`;

    upsertMeta('property', 'og:title', property.title);
    upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:url', pageUrl);
    upsertMeta('property', 'og:image', imageUrl.startsWith('http') ? imageUrl : `${window.location.origin}${imageUrl}`);
    upsertMeta('property', 'og:type', 'website');
    upsertMeta('name', 'description', description);
    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', property.title);
    upsertMeta('name', 'twitter:description', description);
    upsertMeta('name', 'twitter:image', imageUrl.startsWith('http') ? imageUrl : `${window.location.origin}${imageUrl}`);

    return () => {
      document.title = previousTitle;
    };
  }, [property]);
};
